import { downloadFile } from './native-platform.js';
import { dataLayerPayload, validateDataLayerPayload, type DataLayer, type ImportSourceFile, type RetainedSourceFile } from '../shared/data-layer.js';

export async function encodeImportSource(file: File): Promise<ImportSourceFile> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += 8192) binary += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
  return { name: file.name.split(/[\\/]/).pop() || 'import.geojson', base64: btoa(binary) };
}

export function importSourceBytes(source: ImportSourceFile): Uint8Array<ArrayBuffer> {
  return Uint8Array.from(atob(source.base64), (character) => character.charCodeAt(0));
}

export function downloadImportSource(source: ImportSourceFile | RetainedSourceFile): Promise<boolean> {
  return downloadFile('data' in source ? source.data : new Blob([importSourceBytes(source)], { type: 'application/octet-stream' }), source.name);
}

export function retainedImportSources(layer: Pick<DataLayer, 'sourceFiles' | 'retainedSources'>): Array<ImportSourceFile | RetainedSourceFile> {
  return [...layer.sourceFiles ?? [], ...layer.retainedSources ?? []];
}

export function retainImportSource(layer: DataLayer, source: ImportSourceFile): DataLayer {
  const retained = { ...layer, sourceFiles: [source] };
  const validation = validateDataLayerPayload(dataLayerPayload(retained));
  if (!validation.success) throw new Error(validation.errors.join(' '));
  return retained;
}
